import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
import { ordinal } from '../../helper';

function OrderedResults(props) {
  const { data } = props;
  const { datasets } = data;
  const rankings = datasets?.[0]?.percentages ? Object.keys(datasets?.[0]?.percentages) : [];
  const columnArray = [
    { Header: 'Answer Option', accessor: 'label', width: false },
    ...rankings.map((ranking, index) => ({
      Header: ordinal(ranking),
      accessor: `values[${index}]`,
      width: false,
    })),
    { Header: 'Total', accessor: 'total', width: false },
    { Header: 'Score', accessor: 'score', width: false },
  ];
  const tableData = datasets
    .map((dataset) => ({
      label: dataset.label,
      values: rankings.map((_, index) => (
        <>
          {dataset.percentages[index]}%<br />
          {dataset.counts[index]}
        </>
      )),
      total: dataset.total,
      score: dataset.score,
    }))
    .sort((first, second) => first.score - second.score);

  return (
    <div className="engage-results-ordered-results">
      <h4 className="engage-results-engagement-screen__chart-content__subtitle">Results</h4>
      <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} />
    </div>
  );
}

OrderedResults.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        percentages: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
        counts: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
        image: PropTypes.string,
      }).isRequired
    ).isRequired,
  }).isRequired,
};

export default OrderedResults;
